<template>
  <article id="home__faq" class="home__faq">
    <div class="container" id="donation-wrap">
      <h2>
      Perguntas Frequentes
      </h2>
      <details>
        <summary>
          <span class="caret"></span>
          Como vai ser usada a minha doação?
        </summary>
        <p>
          Sua doação vai ser usada exclusivamente na Campanha Presidencial do
          Candidato Ciro Gomes do
          <abbr title="Partido Democrático Trabalhista">
            PDT
          </abbr>.
          A Equipe da Campanha pré-estabeleceu como vai ser usado o recurso
          conforme o volume de arrecadação. No intuito de deixar o processo mais
          transparente, disponibilizamos as metas no link:
          <a href="https://doe.cirogomes.com.br/metas">
            https://doe.cirogomes.com.br/metas
          </a>
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Posso deduzir a doação do imposto de renda do ano que vem?
        </summary>
        <p>
          Não. Porém é necessário declarar a doação que não é dedutível.
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Porque as empresas fazem doação de milhões para campanhas e as pessoas não?
        </summary>
        <p>
          As regras para a eleição de 2018 não permitem doações de empresas para
          campanhas eleitorais. Doações para campanhas eleitorais somente virão
          de pessoas físicas.
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Qual o impacto da transparência dos recursos da campanha?
        </summary>
        <p>
          A divulgação dos dados de financiamento da campanha (doações recebidas
          e gastos realizados) é um mecanismo de responsabilidade pública
          essencial. Fornecer informações sobre o fluxo de dinheiro nas
          campanhas políticas possibilita a fiscalização e uma decisão mais
          qualificada e consciente dos eleitores.
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Quais as normas para doações eleitorais?
        </summary>
        <p>
          A
          <a href="http://www.tse.jus.br/legislacao/codigo-eleitoral/lei-das-eleicoes/lei-das-eleicoes-lei-nb0-9.504-de-30-de-setembro-de-1997">
            Lei 9504/97
          </a>
          e a
          <a href="http://www.tse.jus.br/legislacao-tse/res/2015/RES234632015.html">
            Resolução n. 23.463/2015
          </a>
          do
          <abbr title="Tribunal Superior Eleitoral">
            TSE
          </abbr>
          trata, entre outros
          temas, das doações para as campanhas eleitorais fixando quem pode
          contribuir, quais os limites e formas das contribuições. A seguir, de
          forma resumida, serão apresentados à reflexão os principais pontos
          destas normas legais.
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Quais os limites para doações?
        </summary>
        <p>
            As doações de pessoas físicas não devem ultrapassar 10% dos
            rendimentos brutos do doador. A receita do Imposto de Renda de
            2017/2018 deve ser a base para o cálculo deste limite. Para aqueles
            que não declararam Imposto de Renda, o valor limite para doação é de
            R$2.855. Doações acima do valor de R$1.064,10 devem ser feitas direta
            na conta bancária da campanha. Para mais informações entre em
            contato:
            <a href="mailto:doe@cirogomes.com.br">
              doe@cirogomes.com.br
            </a>
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Quem não pode doar?
        </summary>
        <p>
          Alguns exemplos são, não se limitando a eles: taxistas, serviços de
          radiodifusão sonora, de sons e imagens e outros serviços de
          telecomunicações; serviços de energia elétrica; navegação aérea,
          aeroespacial; serviços de transporte rodoviário, ferroviário e
          aquaviário.
        </p>
        <p>
          Não estão autorizados a doar: estrangeiros, pessoas jurídicas e
          pessoas físicas que exerçam atividade comercial decorrente de
          permissão pública. Sendo que permissão de serviço público é “a
          delegação, a título precário, mediante licitação da prestação de
          serviços públicos, feita pelo poder concedente à pessoa física ou
          jurídica que demonstre capacidade para seu desempenho, para seu
          desempenho, por sua conta e risco”.
        </p>
      </details>
      <details>
        <summary>
          <span class="caret"></span>
          Como é feita a transferência dos recursos e verificação de limites de doações?
        </summary>
        <p>
          As doações financeiras para as campanhas devem ser feitas na conta
          bancária de campanha. Uma vez realizada a doação, é obrigatória a
          emissão de recibo de doação eleitoral no prazo máximo de 72 horas.
          Recomendamos aos doadores e campanhas que verifiquem com antecedência,
          se todo o processo (valor, origem e meio de depósito) se encontra
          dentro dos limites e regras fixadas em lei.
        </p>
      </details>
    </div>
  </article>
</template>

<script>
export default {
  name: 'Faq',
};
</script>

